import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/test/getenv';

  constructor(private _http: HttpClient) { }

  async passageCoGetenv(): Promise<any> {
    const res = await this._http.get(this.apiUri, this.httpOptions).toPromise();
    return res.body;
  }
}
